import React, { useState, useEffect } from "react"
import Flink from '~/components/shared/flink'
import { usePost } from '~/contexts/PostContext'
import { jnstyls, notBlank, imgSize } from '~/utils/helpers'

import QuickCaption from './quick-caption'

import { solid_btn } from "~/styles/app.module.scss"
import * as styles from "~/styles/blog/blog-copy-img.module.scss"
import * as bstyle from "~/styles/blog/blog.module.scss"


const possible_png = (url) => {
  return imgSize(url,500)
}

const BlogCopyImg = ({ blockId, index, has_h1=true }) => {
  const { post, props } = usePost()
  const { quickProds } = props
  const [didLoad, setDidLoad] = useState(false)

  const block = post.data.blocks.find(x => x.id === blockId)
  const { settings } = block

  const is_ext_link = (url) => {
    return url.includes('http') && !(url.includes('buckmason.com') || url.includes('localhost'))
  }

  const clean_link = (url) => {
    return url.replace('https://www.buckmason.com','')
  }

  const ctalink_styles = () => {
    const is_spec = settings.title === 'A LIMITED COLLECTION'
    return [is_spec ? solid_btn : styles.cta_link, is_spec ? styles.solid_btn : '']
  }

  let classes = [bstyle.sec, styles.copy_block, styles.with_image]
  const align_class = notBlank(settings.align) ? `align_${settings.align}` : false
  if (align_class) classes.push(styles[align_class])
  const mob_align = notBlank(settings.mobile_align) ? `alignmob_${settings.mobile_align}` : false
  if (mob_align) classes.push(styles[mob_align])

  useEffect(() => {
    setDidLoad(true)
  }, [])

  return (
    <>
      <div 
        className={jnstyls(classes)}
        block={block.id}
      >
        {(parseInt(settings.scale) < 100) && ( 
          <style>
            {`
              @media only screen and (min-width: 800px) {
                .image${index} {
                  flex: 1 1 ${settings.scale}%;
                  max-width: ${settings.scale}%;
                }
              }
            `}
          </style>
        )}
        {(notBlank(settings?.valign) && settings.valign !== 'center') && (
          <style>
            {`@media only screen and (min-width: 800px) {
              .content${block.id} {
                align-self: ${settings.valign};
              }
            }`}
          </style>
        )}

        <div className={jnstyls([styles.image, `image${index}`])}>
          <img 
            className={styles.img} 
            src={imgSize(settings.sec_image,1100)} 
            alt=""
            height={700} width={1100}
          />
          {notBlank(settings.caption) && (
            <>
              {(didLoad && settings.caption?.includes('/products/') && quickProds.length > 0) ? (
                <QuickCaption 
                  copy={settings.caption} 
                  styles={styles.caption}
                />
              ) : (
                <div className={styles.caption} dangerouslySetInnerHTML={{ __html: settings.caption }} />
              )}
            </>
          )}
          {notBlank(settings.credit) && (
            <div className={bstyle.credit}>{settings.credit}</div>
          )}
        </div>

        <div className={jnstyls([styles.content, `content${block.id}`])}>
          {(notBlank(settings.title) && settings.title.includes('The Mexican')) && (
            <style>
              {`@media only screen and (min-width: 800px) {
                .title${index} {
                  font-size: 4em;
                }
              }
              @media only screen and (max-width: 800px) {
                .title_img${index}  {
                    max-height: 2em;
                }
                .title${index} {
                  font-size: 9.5vw;
                  margin-bottom: 0.75em;
                }
              }
              .title${index} span {
                display: block;
                font-size: 0.5em;
              }`}
            </style>
          )}
          {(notBlank(settings.title) && settings.title.includes('Safari Special')) && (
            <style>
              {`@media only screen and (min-width: 800px) {
                  .title_img${index} {
                    max-height: 3em;
                  }
                }
                @media only screen and (max-width: 800px) {
                  .title_img${index} {
                    max-height: 2em;
                  }
                }`}
            </style>
          )}
          {!has_h1 ? (
            <>
              {notBlank(settings.title_image) && (
                <h1 
                  className={jnstyls([bstyle.title, styles.title, `title${index}`])}
                  blg-mex={settings.title.includes('The Mexican') ? '' : undefined}
                >
                  <img 
                    className={jnstyls([bstyle.title_image, `title_img${index}`])}
                    src={possible_png(settings.title_image)}
                    alt={settings.title}
                    height={100} width={200}
                  />
                </h1>
              )}
              {(!notBlank(settings.title_image) && notBlank(settings.title)) && (
                <h1 
                  className={jnstyls([bstyle.title, styles.title, `title${index}`])}
                  blg-mex={settings.title.includes('The Mexican') ? '' : undefined}
                  dangerouslySetInnerHTML={{ __html: settings.title }} 
                />
              )}
            </>
          ) : (
            <>
              {notBlank(settings.title_image) && (
                <h2 className={jnstyls([bstyle.title, styles.title, styles.title])} style={{textAlign: settings.textalign}}>
                  <img 
                    className={jnstyls([bstyle.title_image, `title_img${index}`])}
                    src={possible_png(settings.title_image)}
                    alt={settings.title}
                    height={100} width={200}
                  />
                </h2>
              )}
              {(!notBlank(settings.title_image) && notBlank(settings.title)) && (
                <h2 
                  className={jnstyls([bstyle.title, styles.title])} 
                  style={{textAlign: settings.textalign}} 
                  dangerouslySetInnerHTML={{ __html: settings.title }} 
                />
              )}
            </>
          )}

          <style>
            {`@media only screen and (min-width: 800px) {
              .text${index} {
                max-width: ${settings.textscale}%;
                text-align: ${settings.textalign};
              }
              .text${index} .story_copy-cta {
                text-align: ${settings.textalign};
              }
            }`}
          </style>
          <div className={jnstyls([styles.text, `text${index}`])}>
            {notBlank(settings.rawcopy) ? (
              <>
                {(didLoad && settings.rawcopy?.includes('/products/') && quickProds.length > 0) ? (
                  <QuickCaption 
                    copy={settings.rawcopy} 
                    styles={''}
                  />
                ) : (
                  <div dangerouslySetInnerHTML={{ __html: settings.rawcopy }} />
                )}
              </>
            ) : (
              <>
                {(didLoad && settings.copy?.includes('/products/') && quickProds.length > 0) ? (
                  <QuickCaption 
                    copy={settings.copy} 
                    styles={''}
                  />
                ) : (
                  <div dangerouslySetInnerHTML={{ __html: settings.copy }} />
                )}
              </>
            )}
        
            {notBlank(settings.copy_cta_link) && (
              <div className={styles.copy_cta} style={{textAlign: settings.textalign}}>
                <Flink 
                  href={clean_link(settings.copy_cta_link)}
                  className={jnstyls(ctalink_styles())}
                >
                  {notBlank(settings.copy_cta_image) ? (
                    <img 
                      className={styles.cta_img}
                      src={possible_png(settings.copy_cta_image)}
                      alt={settings.copy_cta_text}
                      height={100} width={200}
                    />
                  ) : (
                    <>
                      {settings.copy_cta_text}
                    </>
                  )}
                </Flink>
              </div>
            )}
          </div>
        </div>
      </div>

    </>
  )
}

export default BlogCopyImg


